import styled, {css} from 'styled-components';
import helper from '../../utils/helper';

const baseTextStyles = css`
  display: ${(props) => props.display};
  font-family: ${(props) => props.fontFamily};
  text-align: ${(props) => props.align};
  color: ${(props) => props.color || 'inherit'};
  font-weight: ${(props) => props.fontWeight};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom || (props.tag === 'p' ? '3rem' : 0)};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${(props) =>
    props.truncate &&
    `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

const StyledText = styled.span`
  ${baseTextStyles}
  font-size: ${(props) =>
    (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'fontSize') &&
      props.theme.typography.text[props.level].fontSize.xxs) ||
    ''};
  line-height: ${(props) =>
    (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
      props.theme.typography.text[props.level].lineHeight.xxs) ||
    ''};
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.xs}) {
    font-size: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.xs) ||
      ''};
    line-height: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.xs) ||
      ''};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm}) {
    font-size: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.sm) ||
      ''};
    line-height: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.sm) ||
      ''};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.md}) {
    font-size: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.md) ||
      ''};
    line-height: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.md) ||
      ''};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.lg}) {
    font-size: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.lg) ||
      ''};
    line-height: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.lg) ||
      ''};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.xl}) {
    font-size: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'fontSize') &&
        props.theme.typography.text[props.level].fontSize.xl) ||
      ''};
    line-height: ${(props) =>
      (helper.nestedPropExists(props.theme, 'typography', 'text', props.level, 'lineHeight') &&
        props.theme.typography.text[props.level].lineHeight.xl) ||
      ''};
  }
`;

export default StyledText;